<script>
    import ModalButtons from "../Modal/ModalButtons.svelte";
    import dbData from "../../Stores/utilityDBStore.js";
    import { associatedItemsForEntities, authorForItem, createdItemWithEntity, dateTextforTimeMS } from "../../scripts/wpn2Model.js";

    export let item;
    let noteItems = [];
    // let editedText = "";
    let createdText;
    // Options: "show-notes", "create-note"
    let displayMode = "show-notes";

    $: noteItems = associatedItemsForEntities(['Note'], $dbData.all, item, false, false, true, false);

    function saveCreatedNote() {
        const createdNoteItem = createdItemWithEntity('Note', "", 'note', item, $dbData);
        createdNoteItem['note_body'] = createdText.value ?? "";
        noteItems.push(createdNoteItem);
        dbData.addOrReplaceItem(createdNoteItem);
        displayMode = "show-notes";
        return;
    }
</script>

{#if displayMode == "show-notes"}
    <div class="detail-section notes-container">
        <div class="split-title-buttons">
            <div class="detail-section-title split-view-title">Notes</div>
            <div class="right-buttons-panel">
                <a class="active-link" id="note-button-add" href={"#"} on:click={() => (displayMode = "create-note")}>Add Note</a>
            </div>
        </div>
        {#if noteItems.length > 0}
            {#each noteItems as item}
                <div id="note-author-date">
                    <div id="note-author">{authorForItem(item, $dbData.all).name ?? ""}</div>
                    <div id="note-date-time">{dateTextforTimeMS(item.last_updated)}</div>
                </div>
                <div id="note-text">{item.note_body ?? ""}</div>
            {/each}
        {:else}
            <p>No notes yet</p>
        {/if}
    </div>
{:else if displayMode == "create-note"}
    <div class="detail-section notes-container">
        <div class="detail-section-title">New Note</div>
        <div class="note-editor">
            <label for="note-edit">Enter Note</label>
            <textarea
                name="note-create"
                class="note-edit"
                rows="3"
                maxlength="256"
                bind:this={createdText}
            />
        </div>
        <ModalButtons
            actions={["cancel", "save"]}
            on:cancel={() => {displayMode = "show-notes";}}
            on:save={saveCreatedNote}
        />
    </div>
{/if}
<!-- {:else if displayMode == "edit-note"}
    <div class="detail-section notes-container">
        <div class="detail-section-title">Edit Note</div>
        <div class="note-editor">
            <label for="note-edit">Edit Note:</label>
            <textarea 
                name="note-edit"
                class="note-edit"
                rows="3"
                maxlength="256"
                bind:this={editedText}
            />
        </div>
        <ModalButtons
            actions={["cancel", "save"]}
            on:cancel={() => {displayMode = "show-notes"; editedText = "";}}
            on:save={saveEditedNote}
        />
    </div> -->

<style>
    .notes-container {
        margin: 0 auto;
    }
    .note-editor {
        width: 70%;
        margin: auto;
        text-align: center;
        padding: 4px 20px;
    }
    .note-edit {
        width: 100%;
    }
    #note-author-date {
        display: flex;
    }
    #note-author {
        flex: 1;
        color: #0a6ebd;
        padding: 2px 0;
    }
    #note-date-time {        
        flex: 1;
        text-align: right;
        color: gray;
        padding: 2px 0;
    }
    #note-text {
        padding: 4px 0;
    }
</style>
